import { request, uploadFile, API_BASE_URL } from "../../base";
import type { LeadDocument } from "./types";

export const crmDocumentsApi = {
	async listDocuments(
		proId: string,
		leadId: number,
		documentType?: string,
	) {
		const query = documentType ? `?type=${documentType}` : "";
		return request<LeadDocument[]>(
			`/api/pro/${proId}/crm/leads/${leadId}/documents${query}`,
		);
	},

	async uploadDocument(
		proId: string,
		leadId: number,
		file: File,
		data: { name: string; documentType: string },
	) {
		return uploadFile<LeadDocument>(
			`/api/pro/${proId}/crm/leads/${leadId}/documents`,
			file,
			data,
		);
	},

	async deleteDocument(
		proId: string,
		leadId: number,
		documentId: number,
	) {
		return request<{ deleted: true }>(
			`/api/pro/${proId}/crm/leads/${leadId}/documents/${documentId}`,
			{ method: "DELETE" },
		);
	},

	getDocumentDownloadUrl(
		proId: string,
		leadId: number,
		documentId: number,
	) {
		return `${API_BASE_URL}/api/pro/${proId}/crm/leads/${leadId}/documents/${documentId}/download`;
	},
};
